export interface AiPromptFilterValues {
    ownerIds: string[];
}

export function normalizeAiPromptFilterValues(values: unknown, defaults: AiPromptFilterValues): AiPromptFilterValues {
    const ownerIds = values && typeof values === "object" && "ownerIds" in values ? values.ownerIds : undefined;

    if (typeof ownerIds === "string") {
        return {ownerIds: [ownerIds]};
    }

    return {
        ownerIds: Array.isArray(ownerIds) && ownerIds.every(ownerId => typeof ownerId === "string")
            ? ownerIds
            : defaults.ownerIds
    };
}
